// The "Use your location" prompt waits until the user is looking at a trip
// (or a member page that shows nearby picks). Strangers finishing signup or
// the survey should not get a location ask before they have a trip.
const TRIP_DETAIL_RE = /^\/trips\/(?!create(?:\/|$)|building(?:\/|$))[^/]+\/?$/;
const MEMBER_LOCATION_PATHS = ["/dashboard", "/chat"];

export function locationPromptAllowedOnPath(pathname = "") {
  const path = String(pathname || "");
  if (TRIP_DETAIL_RE.test(path)) return true;
  return MEMBER_LOCATION_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
